import { useState } from "react";

type TabType = "news-today" | "emails" | "settings";

export const useActiveTab = () => {
  const [activeTab, setActiveTab] = useState<TabType>(
    (localStorage.getItem("activeTab") as TabType) || "emails"
  );

  const handleTabChange = (tab: TabType) => {
    localStorage.setItem("activeTab", tab);
    setActiveTab(tab);
  };

  return {
    activeTab,
    handleTabChange,
  } as const;
};
